import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, isRef as _isRef, vModelRadio as _vModelRadio, withDirectives as _withDirectives, vModelText as _vModelText, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  id: "navigationPlaceholder",
  style: {"padding-top":"80px"}
}
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "custom-control custom-radio custom-control-inline" }
const _hoisted_4 = { class: "custom-control custom-radio custom-control-inline" }
const _hoisted_5 = { class: "form-group" }
const _hoisted_6 = { class: "form-group" }

import { computed, ref, reactive, watch, onMounted } from 'vue'
    import { guid } from "@common/Guid"
    import { useId, useOrganizationUnitId } from '@common/composables'
    import { useAdminCreatePipelinePage } from '@Integrations/Pipelines/pages-core'
    import AdminNavigationV2 from '@common/AdminNavigationV2.vue'
    import ValidationError from "@common/Components/ValidationError.vue";

    
export default /*@__PURE__*/_defineComponent({
  __name: 'AdminCreatePipelinePage',
  setup(__props) {

    document.title = "Create a pipeline"

    const tid = useOrganizationUnitId()

    const { useCurrentUserQuery, useCreatePipelineCommand, useConnectorProvidersQuery } = useAdminCreatePipelinePage()

    const { modelCurrentUserQueryV1, runCurrentUserQueryV1 } = useCurrentUserQuery()
    const userId = computed(() => modelCurrentUserQueryV1.value?.UserId)

    const connectorProvidersQuery = reactive(useConnectorProvidersQuery(true, false))
    const providers = computed(() => connectorProvidersQuery.model?.Providers || [])

    const { invoke, id, name, description, direction, timeTriggerRecurrency, validationErrors, succeed } = useCreatePipelineCommand(guid(), tid, userId)
    direction.value = 1
    timeTriggerRecurrency.value = null

    watch(succeed, () => {
        if (succeed.value) location.href = `/#/admin/integrations/pipelines/details/${tid}/${id.value}`
    })

    onMounted(() => {
        runCurrentUserQueryV1()
        connectorProvidersQuery.run()
    })

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(AdminNavigationV2, { tid: _unref(tid) }, null, 8 /* PROPS */, ["tid"])
    ]),
    _cache[11] || (_cache[11] = _createStaticVNode("<div class=\"container\"><div class=\"row\"><div class=\"col-lg-7\"><h1 style=\"font-size:2em;font-weight:300;color:#33475b;\">Create a new integration pipeline</h1></div><div class=\"col-lg-5 col-sm-6 text-right\"></div></div></div><hr style=\"border-color:#bbb;margin:20px 0 30px;\">", 2)),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(direction) ? (direction).value = $event : null)),
          value: "1",
          type: "radio",
          id: "dirImport",
          name: "dir",
          class: "custom-control-input"
        }, null, 512 /* NEED_PATCH */), [
          [_vModelRadio, _unref(direction)]
        ]),
        _cache[5] || (_cache[5] = _createElementVNode("label", {
          class: "custom-control-label",
          for: "dirImport"
        }, "Read data from connector", -1 /* CACHED */))
      ]),
      _createElementVNode("div", _hoisted_4, [
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_isRef(direction) ? (direction).value = $event : null)),
          value: "2",
          type: "radio",
          id: "dirExport",
          name: "dir",
          class: "custom-control-input"
        }, null, 512 /* NEED_PATCH */), [
          [_vModelRadio, _unref(direction)]
        ]),
        _cache[6] || (_cache[6] = _createElementVNode("label", {
          class: "custom-control-label",
          for: "dirExport"
        }, "Write data to connector", -1 /* CACHED */))
      ]),
      _cache[9] || (_cache[9] = _createElementVNode("br", null, null, -1 /* CACHED */)),
      _cache[10] || (_cache[10] = _createElementVNode("br", null, null, -1 /* CACHED */)),
      _createElementVNode("div", _hoisted_5, [
        _cache[7] || (_cache[7] = _createElementVNode("label", { for: "Name" }, "Name:", -1 /* CACHED */)),
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_isRef(name) ? (name).value = $event : null)),
          type: "text",
          class: "form-control",
          placeholder: "Name of a pipeline"
        }, null, 512 /* NEED_PATCH */), [
          [_vModelText, _unref(name)]
        ]),
        _createVNode(ValidationError, {
          context: "Name",
          errors: _unref(validationErrors)
        }, null, 8 /* PROPS */, ["errors"])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _cache[8] || (_cache[8] = _createElementVNode("label", { for: "Description" }, "Description:", -1 /* CACHED */)),
        _withDirectives(_createElementVNode("textarea", {
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_isRef(description) ? (description).value = $event : null)),
          class: "form-control",
          placeholder: "Description of a pipeline"
        }, null, 512 /* NEED_PATCH */), [
          [_vModelText, _unref(description)]
        ]),
        _createVNode(ValidationError, {
          context: "Description",
          errors: _unref(validationErrors)
        }, null, 8 /* PROPS */, ["errors"])
      ]),
      _createElementVNode("button", {
        onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_unref(invoke) && _unref(invoke)(...args))),
        class: "btn btn-primary btn-lg"
      }, "Create")
    ])
  ]))
}
}

})